import React, { useEffect, useState } from 'react';
import { NoNotificationView } from './noNotificationView';
import { SingleNotificationsView } from './singleNotificationView';
import axios from 'axios';
import { getUrl } from '../../utils/getUrl';
import { Config } from '../../config/envConfig';
import { ProcessType } from '@quyva/common';

export const NotificationsView = ({ socket, notifications, showNotifications }) => {
    const [alertNotifications, setAlertNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAlertNotifications = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('current'));
                if (!user || !user.email || !user.token) {
                    setLoading(false);
                    return;
                }

                const dynamicUrl = getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getNotificationHistory?email=${user.email}`
                );

                const encodedToken = encodeURIComponent(user.token);
                const response = await axios.get(dynamicUrl, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: encodedToken,
                    },
                });

                if (response && response.data?.notificationHistory) {
                    // Filter only ALERT notifications
                    const alerts = response.data.notificationHistory
                        .filter((notification) => notification.process === ProcessType.ALERT)
                        .map((notification) => ({
                            userMail: notification.user_mail,
                            repoId: notification.repo_id,
                            repoName: notification.repo_name,
                            process: notification.process,
                            progress: notification.progress,
                            message: notification.message,
                            timeStamp: notification.timestamp,
                            userId: notification.user_mail,
                        }));
                    setAlertNotifications(alerts);
                }
                setLoading(false);
            } catch (error) {
                console.error('Failed to load alert notifications:', error?.message);
                setLoading(false);
            }
        };

        if (showNotifications) {
            fetchAlertNotifications();
        }
    }, [showNotifications]);

    if (loading) {
        return (
            <div
                className={`${
                    window.innerWidth < 1024
                        ? 'w-[16rem] h-[10rem]'
                        : 'w-[18rem] h-[10rem]'
                } border rounded-xl shadow-inner p-3 bg-backgrounds-slate flex items-center justify-center`}
            >
                <div className='text-texts-secondary300'>Loading...</div>
            </div>
        );
    }

    if (alertNotifications.length === 0) {
        return (
            <div
                className={`${
                    window.innerWidth < 1024
                        ? 'w-[16rem] h-[10rem]'
                        : 'w-[18rem] h-[10rem]'
                } border rounded-xl shadow-inner p-3 bg-backgrounds-slate flex items-center justify-center`}
            >
                <NoNotificationView />
            </div>
        );
    }

    return (
        <div
            className={`${
                window.innerWidth < 1024 ? 'w-[20rem]' : 'w-[24rem]'
            } max-h-[28rem] overflow-y-auto border rounded-xl shadow-inner p-3 bg-backgrounds-slate`}
        >
            {alertNotifications.map((notification, index) => (
                <SingleNotificationsView
                    key={`alert-${notification.repoId}-${index}`}
                    socket={socket}
                    notification={notification}
                />
            ))}
        </div>
    );
};
